import React from 'react'
import PropTypes from 'prop-types'

const PublicDSIBHeader = ({ brand, title }) => (
  <header className="dsib-emailVerification__header">
    <div className="dsib-emailVerification__brand">{brand}</div>
    <div className="dsib-emailVerification__banner">
      <h1 className="dsib-emailVerification__bannerTitle">{title}</h1>
    </div>
  </header>
)

PublicDSIBHeader.propTypes = {
  brand: PropTypes.string,
  title: PropTypes.string,
}

PublicDSIBHeader.defaultProps = {
  brand: 'Sainsbury\'s',
  title: 'Digital sign-in book',
}

export default PublicDSIBHeader
